import { styled } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

export const SquareAlert = styled(Alert)({
  borderRadius: 0,
})
